/// <summary>
/// 容灾时间处理类(服务器刚启动，缓解大量请求涌入)
/// </summary>

import KitLog from "../KitLog";
import {KitTrack} from "./KitTrack";

/// <author>xiexingwu</author>
export class DisasterTimeHelper {
    private static reportCount = 0;

    static Reset() {
        return this.reportCount = 0;
    }

    static AddFailCount() {
        this.reportCount++;
    }

    /// <summary>
    /// 计算容灾时间（缓解服务启动压力）
    /// </summary>
    /// <returns></returns>
    static CalcDelayTime(): number {
        let delayTime = 0;
        if (this.reportCount <= 3)
            delayTime = 0;
        else if (this.reportCount == 4)
            delayTime = 20;
        else if (this.reportCount == 5)
            delayTime = 40;
        else if (this.reportCount == 6)
            delayTime = 80;
        else delayTime = 120;
        if (delayTime > 0 && KitLog.IsLog) KitTrack.Log(`[轮询]计算容灾延缓时间${delayTime},失败次数:${this.reportCount}`);
        return delayTime;
    }
}